import { render, staticRenderFns } from "./DistrictLocator.vue?vue&type=template&id=508a6899"
import script from "./DistrictLocator.vue?vue&type=script&lang=js"
export * from "./DistrictLocator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports